<template>
  <div>
    <b-card-body
      v-if="tool"
      class="pt-0 pb-25"
    >
      <div>
        <!-- sorting  -->
        <b-form-group
          class="mb-md-1 mr-1"
        >
          <b-button
            v-if="buttonAdd"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="primary mr-2 mb-sm-1 mb-md-0"
            @click="$emit('addList')"
          >
            <span class="align-middle">Add New Channel</span>
            <feather-icon
              icon="PlusCircleIcon"
              class="ml-50"
            />
          </b-button>
          <!-- <b-dropdown
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            text="Download"
            variant="outline-primary"
            class="mr-1 mt-1 hidden"
          >
            <b-dropdown-item @click="downloader('pdf')">
              PDF
            </b-dropdown-item>
          </b-dropdown> -->
          <!-- <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
          >
            <span class="align-middle">Print</span>
            <feather-icon
              icon="PrinterIcon"
              class="ml-50"
            />
          </b-button> -->
        </b-form-group>

        <!-- filter -->
        <b-row>
          <b-col
            lg="2"
            md="12"
          >
            <b-row>
              <b-col>
                <b-form-group>
                  <b-dropdown
                    v-if="buttonDownload"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    text="Download"
                    block
                    variant="outline-primary"
                    class="w-100 pr-md-1"
                    style="min-width:10rem;"
                  >
                    <b-dropdown-item @click="downloader('pdf')">
                      PDF
                    </b-dropdown-item>
                    <b-dropdown-item @click="downloader('excel')">
                      EXCEL
                    </b-dropdown-item>
                    <!-- <b-dropdown-item @click="downloader('csv')">
              CSV
            </b-dropdown-item>
            <b-dropdown-item @click="downloader('xlsx')">
              Excel
            </b-dropdown-item> -->
                  </b-dropdown>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col
            lg="4"
            md="12"
          >
            <div v-if="filterSearch">
              <b-row>
                <b-col>
                  <b-form-group
                    class="mt-lg-0"
                  >
                    <b-input-group class="input-group-merge input-search mr-md-1">
                      <b-form-input
                        id="filterInput"
                        v-model="search"
                        class=""
                        type="search"
                        placeholder="Search..."
                      />
                      <b-input-group-append is-text>
                        <feather-icon icon="SearchIcon" />
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col
            lg="6"
            md="12"
          >
            <div v-if="filterDate">
              <b-row>
                <b-col
                  md="4"
                  sm="12"
                >
                  <b-form-group class="form-group-date">
                    <b-form-datepicker
                      id="startdate"
                      v-model="startdate"
                      class="input-date startdate"
                      locale="ind"
                      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                      placeholder="Start Period"
                      @context="onContext"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  md="4"
                  sm="12"
                >
                  <b-form-group class="form-group-date">
                    <b-form-datepicker
                      id="enddate"
                      v-model="enddate"
                      class="input-date enddate"
                      locale="ind"
                      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                      placeholder="End Period"
                      @context="onContext"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  md="4"
                  sm="12"
                >
                  <b-form-group>
                    <b-button
                      class="btn btn-primary w-100"
                      :disabled="disabledBtnFilter"
                      @click="filterDataByDate"
                    >
                      <feather-icon icon="FilterIcon" />
                      Filter
                    </b-button>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-card-body>

    <b-table
      ref="dataTable"
      striped
      hover
      responsive
      selectable
      class="position-relative nowrap-table"
      head-variant="light"
      :items="dataTable.data"
      :fields="fieldTable"
      :select-mode="selectMode"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      :filter-included-fields="filterOn"
      show-empty
      @row-selected="onRowSelected"
    >
      <template
        v-for="(_, slotName) of $scopedSlots"
        v-slot:[slotName]="scope"
      >
        <slot
          :name="slotName"
          v-bind="scope"
        />
      </template>
      <template
        v-if="status"
        #cell(status)="data"
      >
        <b-badge :variant="status[1][data.value]">
          {{ status[0][data.value] }}
        </b-badge>
      </template>
      <template
        v-if="action"
        #cell(actions)="data"
      >
        <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          variant="outline-primary"
          size="sm"
          @click="viewDetail(data.item.client_id)"
        >
          <span class="align-middle">View</span>
        </b-button>
      </template>
    </b-table>
    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">

      <!-- page length -->
      <b-form-group
        v-if="information"
        class="text-nowrap mb-md-0 mr-1"
      >
        <label>
          <span>Showing {{ dataTable.from }} </span> <span> to {{ dataTable.to }}</span> <span> of {{ dataTable.total }} entries</span>
        </label>
        <!-- <b-form-select
          id="perPageSelect"
          v-model="perPage"
          size="sm"
          inline
          :options="pageOptions"
        /> -->
      </b-form-group>

      <!-- pagination -->
      <div>
        <b-pagination
          v-if="pagination"
          v-model="page"
          :total-rows="dataTable.total"
          :per-page="dataTable.per_page"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
          class="mb-0"
          @change="getList"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination>
      </div>
    </b-card-body></div>
</template>

<script>
import {
  BTable, BBadge, BFormGroup, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BCardBody, BDropdown, BDropdownItem, BButton, BFormDatepicker, BRow, BCol,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
// import { mapGetters } from 'vuex'
// import { mapActions } from 'vuex'

export default {
  components: {
    BTable,
    // BAvatar,
    BBadge,
    BFormGroup,
    // BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BDropdown,
    BDropdownItem,
    BButton,
    BCardBody,
    BFormDatepicker,
    BRow,
    BCol,
  },
  directives: {
    Ripple,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    dataTable: Object,
    // eslint-disable-next-line vue/require-default-prop
    fieldTable: Array,
    // eslint-disable-next-line vue/require-default-prop
    status: Array,
    tableFor: {
      default: 'account',
      type: String,
    },
    buttonAdd: {
      default: false,
      type: Boolean,
    },
    buttonDownload: {
      default: true,
      type: Boolean,
    },
    dataFor: {
      default: '',
      type: String,
    },
    mutationFor: {
      default: '',
      type: String,
    },
    filterDate: {
      default: false,
      type: Boolean,
    },
    filterSearch: {
      default: true,
      type: Boolean,
    },
    tool: {
      default: true,
      type: Boolean,
    },
    action: {
      default: true,
      type: Boolean,
    },
    information: {
      default: true,
      type: Boolean,
    },
    pagination: {
      default: true,
      type: Boolean,
    },
    selectMode: {
      default: 'multi',
      type: String,
    },
    list: {
      default: 'getDataList',
      type: String,
    },
  },
  data() {
    return {
      // filter: null,
      // perPage: 6,
      // pageOptions: [6, 10],
      // totalRows: 1,
      // currentPage: 1,
      // sortBy: '',
      // sortDesc: false,
      item: [],
      sortDirection: 'asc',
      filterOn: [],
      disabledBtnFilter: true,
      startdate: '',
      enddate: '',
      selected: [],
    }
  },
  computed: {
    // ...mapGetters('datas', {
    //   selectedRow: 'getSelectedRow',
    // }),
    sortOptions() {
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    page: {
      get() {
        return this.$store.state[this.tableFor][this.dataFor].items.current_page
      },
      set(val) {
        this.$store.commit(`${this.tableFor}/SET_${this.mutationFor}_CURRENT_PAGE`, val)
      },
    },
    sortBy: {
      get() {
        return this.$store.state[this.tableFor][this.dataFor].sortBy
      },
      set(val) {
        this.$store.commit(`${this.tableFor}/SET_${this.mutationFor}_SORT_BY`, val)
        this.$store.dispatch(`${this.tableFor}/${this.list}`)
      },
    },
    sortDesc: {
      get() {
        return this.$store.state[this.tableFor][this.dataFor].sortDesc
      },
      set(val) {
        this.$store.commit(`${this.tableFor}/SET_${this.mutationFor}_SORT_DESC`, val)
        this.$store.dispatch(`${this.tableFor}/${this.list}`)
      },
    },
    search: {
      get() {
        return this.$store.state[this.tableFor][this.dataFor].search
      },
      set(val) {
        this.$store.commit(`${this.tableFor}/SET_${this.mutationFor}_SEARCH`, val)
        this.$store.dispatch(`${this.tableFor}/${this.list}`)
      },
    },
    // selectedRow: {
    //   get() {
    //     return this.$store.state.datas.selectedRowTable
    //   },
    //   set(val) {
    //     this.$store.commit('datas/setSelectedRow', val)
    //   },
    // },
  },
  watch: {
    page() {
      this.$store.dispatch(`${this.tableFor}/${this.list}`)
    },
    search() {
      this.$store.dispatch(`${this.tableFor}/${this.list}`)
    },
    sortBy() {
      this.$store.dispatch(`${this.tableFor}/${this.list}`)
    },
  },
  mounted() {
    this.item = this.dataTable.data
  },
  methods: {
    getList(val) {
      this.$store.commit(`${this.tableFor}/SET_${this.mutationFor}_CURRENT_PAGE`, val)
      this.$store.dispatch(`${this.tableFor}/${this.list}`)
    },
    viewDetail(id) {
      const routeName = this.$route.matched[0].path
      this.$router.push({ path: `${routeName}/view/${id}` })
    },
    onContext() {
      if (this.startdate !== '' && this.enddate !== '') {
        this.disabledBtnFilter = false
      } else {
        this.disabledBtnFilter = true
        // this.$store.commit('topup/SET_STARTDATE', '')
        // this.$store.commit('topup/SET_ENDDATE', '')
      }
    },
    filterDataByDate() {
      this.$store.commit(`${this.tableFor}/SET_STARTDATE`, this.startdate)
      this.$store.commit(`${this.tableFor}/SET_ENDDATE`, this.enddate)
      this.$store.dispatch(`${this.tableFor}/${this.list}`)
    },
    onRowSelected(items) {
      this.$store.state.datas.selectedRowTable = items
    },
    selectAllRows() {
      this.$refs.dataTable.selectAllRows()
    },
    clearAllRows() {
      this.$refs.dataTable.clearSelected()
    },
    selectedRow(index) {
      this.$refs.dataTable.selectRow(index)
    },
    clearSelected() {
      this.$refs.dataTable.clearSelected()
    },
    unselectRow(index) {
      this.$refs.dataTable.unselectRow(index)
    },
    forceFileDownload(response, title) {
      const url = window.URL.createObjectURL(new Blob([response]))
      // const url = window.URL.createObjectURL(response)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', title)
      document.body.appendChild(link)
      link.click()
      // URL.revokeObjectURL(link.href)
    },
    downloader(format) {
      // const sendData = {
      //   type: 'download',
      //   format,
      // }
      const frm = (format === 'excel') ? 'xlsx' : format
      const dates = this.formatDate()
      this.$store.dispatch(`${this.tableFor}/downloadTable`, format).then(res => {
        this.forceFileDownload(res, `${this.tableFor}_${dates}.${frm}`)
      })
    },
    formatDate() {
      const dateNow = new Date()
      const year = dateNow.getFullYear()
      const month = dateNow.getMonth() + 1
      const date = dateNow.getDate()
      return `${year}-${month}-${date}`
    },
  },
}
</script>

<style scoped>
.print-download {
  margin-right: 230px !important;
  margin-bottom:1rem;
}
.btn-primary {
  background-color: #4B6AAE !important;
  border: 1px solid #4B6AAE !important;
}
.table .thead-light th {
  background-color: #F4F7FF !important;
}
.use-filter .input-search{
    min-width: 14rem;
    width: calc(100vw - 74rem) !important;
    margin-bottom: 1rem;
    max-width:30rem;
}
.use-filter .form-group-date{
    width:auto;
}
@media screen and (max-width: 600px){
/deep/.btn.dropdown-toggle {
    width: 100% !important;
}
}
</style>
